<template>
  <div class="d-flex align-items-center container__user-profile">
    <div
      :class="`avatar-icon-wrapper avatar-initials cursur-pointer avatar-icon-${size} badge__user-profile`"
      @click="onClickProfile"
    >
      <b-skeleton v-if="isFetching" type="avatar" :size="`${size}px`"></b-skeleton>

      <BaseAvatar v-else id="user-menu" :size="size" :name="userName" :img="profileImageSrc" />
    </div>
    <div class="text__user-fullname">
      <slot name="name" />
    </div>
  </div>
</template>

<script>
import BaseAvatar from '@/components/base-components/BaseAvatar.vue';
import Upload from '@/models/Upload';

export default {
  name: 'BaseUserProfile',

  components: {
    BaseAvatar
  },

  props: {
    userName: {
      type: String,
      default: ''
    },

    size: {
      type: Number,
      default: 44
    },

    picture: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      profileImageSrc: null,
      isFetching: false
    };
  },

  computed: {
    avatarIcon() {
      if (!this.userName) return;

      const words = this.userName.split(' ');
      if (words.length === 1) return words[0][0].toUpperCase();
      const shortName = words[0][0] + words[words.length - 1][0];

      return shortName.toUpperCase();
    }
  },

  async mounted() {
    if (this.picture) {
      this.isFetching = true;

      const { response } = await Upload.api().fetchPresignedUrl(this.picture.id);

      this.profileImageSrc = response.data.url;

      this.isFetching = false;
    }
  },

  methods: {
    onClickProfile() {
      this.$emit('onClickProfile', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.cursur-pointer {
  cursor: pointer;
}
</style>
